import { Database } from './database.types';

export type ProfileRow = Database['public']['Tables']['profiles']['Row'];

export class Profile {
  id: string;
  userId: string;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  displayName: string | null;
  avatarUrl: string | null;
  status: string;
  statusSource: string;
  isActive: boolean;
  azureOid: string | null;
  hasOutlookMailbox: boolean;
  outlookMailboxCheckedAt: string | null;
  statusUpdatedAt: string;
  createdAt: string;
  updatedAt: string;

  /** Creates a profile from partial data. */
  constructor(profile?: Partial<Profile>) {
    this.id = profile?.id ?? '';
    this.userId = profile?.userId ?? '';
    this.email = profile?.email ?? null;
    this.firstName = profile?.firstName ?? null;
    this.lastName = profile?.lastName ?? null;
    this.displayName = profile?.displayName ?? null;
    this.avatarUrl = profile?.avatarUrl ?? null;
    this.status = profile?.status ?? 'off';
    this.statusSource = profile?.statusSource ?? 'manual';
    this.isActive = profile?.isActive ?? true;
    this.azureOid = profile?.azureOid ?? null;
    this.hasOutlookMailbox = profile?.hasOutlookMailbox ?? false;
    this.outlookMailboxCheckedAt = profile?.outlookMailboxCheckedAt ?? null;
    this.statusUpdatedAt = profile?.statusUpdatedAt ?? '';
    this.createdAt = profile?.createdAt ?? '';
    this.updatedAt = profile?.updatedAt ?? '';
  }

  /** Builds a profile from a database row. */
  static fromRow(row: ProfileRow): Profile {
    return new Profile({
      id: row.id,
      userId: row.user_id,
      email: row.email,
      firstName: row.first_name,
      lastName: row.last_name,
      displayName: row.display_name,
      avatarUrl: row.avatar_url,
      status: row.status,
      statusSource: row.status_source,
      isActive: row.is_active,
      azureOid: row.azure_oid,
      hasOutlookMailbox: row.has_outlook_mailbox,
      outlookMailboxCheckedAt: row.outlook_mailbox_checked_at,
      statusUpdatedAt: row.status_updated_at,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    });
  }

  /** Returns the user's displayable full name. */
  get fullName(): string {
    const name = [this.firstName, this.lastName].filter(Boolean).join(' ').trim();
    return name || this.displayName || this.email || 'Utilisateur';
  }
}
